import React, { useState } from "react";
import Biz1 from "../assets/biz1.png";
import Biz2 from "../assets/biz2.png";
import Biz3 from "../assets/biz3.png";
const VirtualBizLabGuide = () => {
  const [selectedExpert, setSelectedExpert] = useState("CEO");

  // Custom SVG Icons
  const Briefcase = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M20 7h-4l-2-3h-4l-2 3H4a2 2 0 00-2 2v9a2 2 0 002 2h16a2 2 0 002-2V9a2 2 0 00-2-2z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16 21v-8a2 2 0 00-2-2h-4a2 2 0 00-2 2v8"
      />
    </svg>
  );

  const Users = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2M9 7a4 4 0 100-8 4 4 0 000 8zM23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75"
      />
    </svg>
  );

  const ChartBar = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zM13 19V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
      />
    </svg>
  );

  const FileText = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M14 2v6h6M16 13H8M16 17H8M10 9H8"
      />
    </svg>
  );

  const Sparkles = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
      />
    </svg>
  );

  const AlertTriangle = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
      />
    </svg>
  );

  const Calendar = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
  );

  const DollarSign = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 2v20M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6"
      />
    </svg>
  );

  const TrendingUp = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M23 6l-9.5 9.5-5-5L1 18"
      />
      <path strokeLinecap="round" strokeLinejoin="round" d="M17 6h6v6" />
    </svg>
  );

  const Shield = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
      />
    </svg>
  );

  const Lightbulb = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9 18h6m-3-16a7 7 0 00-7 7c0 2 1 3.5 2 5s2 3 2 5h6c0-2 1-3.5 2-5s2-3 2-5a7 7 0 00-7-7z"
      />
    </svg>
  );

  const MessageCircle = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"
      />
    </svg>
  );

  const Check = (props) => (
    <svg
      {...props}
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      strokeWidth={2}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  );

  const ExpertCard = ({ name, role, description, icon: Icon, selected }) => (
    <div
      className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
        selected
          ? "border-green-500 bg-green-50"
          : "border-gray-200 hover:border-green-300"
      }`}
      onClick={() => setSelectedExpert(name)}
    >
      <div className="flex items-start gap-3">
        <div
          className={`w-10 h-10 rounded-lg flex items-center justify-center ${
            selected ? "bg-green-500 text-white" : "bg-gray-100 text-gray-600"
          }`}
        >
          <Icon className="w-5 h-5" />
        </div>
        <div className="flex-1">
          <h4 className="font-semibold text-gray-800">{name}</h4>
          <p className="text-sm text-gray-600">{role}</p>
          <p className="text-xs text-gray-500 mt-1">{description}</p>
        </div>
        {selected && <Check className="w-5 h-5 text-green-500" />}
      </div>
    </div>
  );

  const DummyImage = ({ title, className = "" }) => (
    <div
      className={`bg-gradient-to-br from-green-100 to-emerald-100 rounded-lg shadow-md flex items-center justify-center p-8 ${className}`}
    >
      <div className="text-center">
        <Briefcase className="w-16 h-16 text-green-400 mx-auto mb-3" />
        <p className="text-green-600 font-medium">{title}</p>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-green-50">
      {/* Hero Section */}
      <section className="relative overflow-hidden py-20">
        <div className="absolute inset-0 bg-gradient-to-br from-green-600/10 via-emerald-600/10 to-green-600/10"></div>
        <div className="relative container mx-auto px-6">
          <div className="text-center space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-green-100 rounded-full text-green-700 text-sm font-medium">
              <Sparkles className="w-4 h-4" />
              Virtual Business Simulation
            </div>

            <h1 className="text-5xl lg:text-6xl font-bold bg-gradient-to-r from-green-600 to-emerald-600 bg-clip-text text-transparent">
              Virtual Biz Lab
            </h1>

            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              Virtual Biz Lab은 사업이나 새로운 프로젝트를 준비하기 이전 한정된
              자금으로 시장조사부터 리스크관리 기술 개발 요소까지 갖춘 가상의
              전문가 집단에서 사업을 시행하는 서비스입니다.
            </p>

            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              해당 기능을 통해 사업 이전 가상의 사업 시나리오를 보며 여러가지
              케이스를 준비하고 대응하며, 새로운 인사이트를 도출할 수 있습니다.
            </p>
          </div>
        </div>
      </section>

      {/* Notice Section */}
      <section className="py-8 bg-amber-50 border-y border-amber-200">
        <div className="container mx-auto px-6">
          <div className="flex items-start gap-4 max-w-4xl mx-auto">
            <AlertTriangle className="w-6 h-6 text-amber-600 flex-shrink-0 mt-1" />
            <div className="space-y-3">
              <h3 className="font-semibold text-gray-800">
                ⚠️ 서비스 이용 안내
              </h3>
              <p className="text-gray-700">
                Virtual Biz Lab은 AI 기반 시뮬레이션으로 실제 사업 결과와 다를
                수 있습니다. 참고 자료로 활용하시고, 실제 사업 결정은 전문가와
                상담하시기 바랍니다.
              </p>
              <div className="flex items-center gap-2 mt-3">
                <Calendar className="w-4 h-4 text-gray-500" />
                <span className="text-sm text-gray-600">
                  베타 서비스 운영 중 (2025년 12월 정식 출시 예정)
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Main Features */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-2xl border border-green-200">
              <h3 className="text-lg font-semibold text-gray-800 mb-4 flex items-center gap-2">
                <Briefcase className="w-5 h-5 text-green-600" />
                Virtual Biz Lab의 2가지 핵심 기능
              </h3>
              <div className="grid md:grid-cols-2 gap-4">
                <div className="bg-white p-4 rounded-lg border border-green-100">
                  <TrendingUp className="w-8 h-8 text-green-600 mb-2" />
                  <h4 className="font-semibold text-gray-800 mb-1">
                    비즈니스 실현하기
                  </h4>
                  <p className="text-sm text-gray-600">
                    실현하고자 하는 비즈니스를 등록하고 가상 시뮬레이션을
                    시작합니다.
                  </p>
                </div>
                <div className="bg-white p-4 rounded-lg border border-green-100">
                  <FileText className="w-8 h-8 text-green-600 mb-2" />
                  <h4 className="font-semibold text-gray-800 mb-1">
                    비즈니스 레포트
                  </h4>
                  <p className="text-sm text-gray-600">
                    AI가 실현된 비즈니스 결과를 분석한 상세 레포트를 확인합니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Step by Step Guide */}
      <section className="py-16">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto space-y-12">
            <h2 className="text-3xl font-bold text-center text-gray-800">
              사용 가이드
            </h2>

            {/* Step 1 */}
            <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">1</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">
                  Virtual Biz Lab 메인 화면
                </h3>
              </div>
              <img src={Biz1} alt="서비스 설명 이미지" />
              <p className="bg-green-50 border-l-4 border-green-500 p-4 rounded-md shadow-sm text-gray-800 leading-relaxed">
                Virtual Biz Lab은 크게{" "}
                <span className="font-semibold">2가지 탭</span>으로 나뉩니다.
                <br />•{" "}
                <span className="text-green-600 font-medium">
                  비즈니스 실현하기
                </span>{" "}
                - 실현하고자하는 비즈니스를 등록합니다.
                <br />•{" "}
                <span className="text-green-600 font-medium">
                  비즈니스 레포트
                </span>{" "}
                - AI가 실현된 비즈니스를 볼 수 있습니다.
                <br />
                <span className="text-sm text-gray-600 mt-2 block">
                  실현시킨 비즈니스 결과물을 레포트에서 볼 수 있습니다.
                </span>
              </p>
            </div>

            {/* Step 2 */}
            <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">2</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">
                  비즈니스 정보 입력
                </h3>
              </div>
              <img src={Biz2} alt="서비스 설명 이미지" />

              <div className="space-y-4">
                <p className="text-gray-600">
                  비즈니스 내용부터 초기 자본금, 시장 규모 등 또한 사업 기반에
                  조금 쉽게 풀어나갈 수 있는 참고사항등을 자세히 기재할수록
                  좋습니다.
                </p>

                <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                  <div className="flex items-start gap-3">
                    <Lightbulb className="w-5 h-5 text-blue-600 mt-0.5" />
                    <div>
                      <p className="text-sm text-gray-700">
                        <span className="font-semibold">TIP:</span> 시장규모를
                        모르시는 경우
                        <span className="font-medium text-blue-600">
                          {" "}
                          "조사가 필요"
                        </span>{" "}
                        등으로 대체해주시면 좋습니다.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-4 mt-6">
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2 flex items-center gap-2">
                      <DollarSign className="w-4 h-4 text-green-600" />
                      필수 입력 정보
                    </h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• 사업 아이템 및 설명</li>
                      <li>• 초기 자본금</li>
                      <li>• 목표 시장</li>
                      <li>• 예상 시장 규모</li>
                    </ul>
                  </div>
                  <div className="bg-gray-50 p-4 rounded-lg">
                    <h4 className="font-semibold text-gray-800 mb-2 flex items-center gap-2">
                      <Shield className="w-4 h-4 text-green-600" />
                      선택 입력 정보
                    </h4>
                    <ul className="text-sm text-gray-600 space-y-1">
                      <li>• 경쟁사 정보</li>
                      <li>• 차별화 전략</li>
                      <li>• 리스크 요인</li>
                      <li>• 기타 참고사항</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Expert Selection */}
            <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">3</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">
                  전문가 팀 구성
                </h3>
              </div>

              <div className="bg-red-50 p-4 rounded-lg border border-red-200 mb-6">
                <div className="flex items-start gap-3">
                  <AlertTriangle className="w-5 h-5 text-red-600 mt-0.5" />
                  <div>
                    <p className="text-gray-700">
                      <span className="font-semibold text-red-600">
                        필수 선택사항:
                      </span>{" "}
                      CEO는 필수적으로 선택해야하는 전문인력이며
                      <br />
                      <span className="font-medium">
                        CEO + 최소 1인 이상의 전문가를 선택해주셔야 합니다.
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-4">
                <ExpertCard
                  name="CEO"
                  role="최고경영자"
                  description="비즈니스 전반적인 전략 수립과 의사결정"
                  icon={Briefcase}
                  selected={selectedExpert === "CEO"}
                />
                <ExpertCard
                  name="CTO"
                  role="기술 리더"
                  description="기술 개발 및 혁신 전략 담당"
                  icon={Lightbulb}
                  selected={selectedExpert === "CTO"}
                />
                <ExpertCard
                  name="CFO"
                  role="리스크 관리자"
                  description="재무 관리 및 투자 전략 수립"
                  icon={DollarSign}
                  selected={selectedExpert === "CFO"}
                />
                <ExpertCard
                  name="CMO"
                  role="브랜드 전략가"
                  description="마케팅 전략 및 브랜드 관리"
                  icon={TrendingUp}
                  selected={selectedExpert === "CMO"}
                />
              </div>
            </div>

            {/* Step 3 */}
            <div className="bg-white rounded-2xl shadow-xl p-8 space-y-6">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center">
                  <span className="text-green-600 font-bold">4</span>
                </div>
                <h3 className="text-xl font-semibold text-gray-800">
                  비즈니스 레포트 확인
                </h3>
              </div>
              <img src={Biz3} alt="서비스 설명 이미지" />
              <p className="text-gray-600">
                비즈니스 실현하기를 진행하신 후 레포트에서 완료된 레포트를
                보시면 비즈니스 실행도중 AI들의 대화와 아래 최종적인 AI 리뷰를
                보실 수 있습니다.
              </p>

              <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-lg border border-green-200">
                <h4 className="font-semibold text-gray-800 mb-4 flex items-center gap-2">
                  <FileText className="w-5 h-5 text-green-600" />
                  레포트 구성 요소
                </h4>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5" />
                    <div>
                      <h5 className="font-medium text-gray-800">
                        AI 전문가 대화 내용
                      </h5>
                      <p className="text-sm text-gray-600">
                        선택한 전문가들이 비즈니스를 논의하는 과정을 확인할 수
                        있습니다.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <ChartBar className="w-5 h-5 text-green-600 mt-0.5" />
                    <div>
                      <h5 className="font-medium text-gray-800">
                        시장 분석 결과
                      </h5>
                      <p className="text-sm text-gray-600">
                        시장 규모, 성장 가능성, 경쟁 환경 등을 분석한 결과를
                        제공합니다.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Shield className="w-5 h-5 text-green-600 mt-0.5" />
                    <div>
                      <h5 className="font-medium text-gray-800">리스크 평가</h5>
                      <p className="text-sm text-gray-600">
                        예상되는 위험 요소와 대응 방안을 제시합니다.
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <Sparkles className="w-5 h-5 text-green-600 mt-0.5" />
                    <div>
                      <h5 className="font-medium text-gray-800">
                        최종 AI 리뷰
                      </h5>
                      <p className="text-sm text-gray-600">
                        종합적인 사업 성공 가능성과 개선 방향을 제안합니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default VirtualBizLabGuide;
